(() => {
  const root = document.querySelector('[data-funnel-studio]');
  if (!root) return;
  const steps = [...document.querySelectorAll('[data-funnel-step]')];
  const status = document.querySelector('[data-funnel-status]');
  const loader=document.querySelector('[data-funnel-loader]');
  const setLoader=active=>{if(!loader)return;if(active&&!loader.open)loader.showModal();else if(!active&&loader.open)loader.close();document.documentElement.classList.toggle('pw-funnel-loading-open',active);};
  loader?.addEventListener('close',()=>document.documentElement.classList.remove('pw-funnel-loading-open'));
  const links = [...document.querySelectorAll('[data-funnel-style]')];
  const assets = JSON.parse(document.querySelector('[data-funnel-assets]').textContent);
  let loading, selecting = false, mounted = false, lastEvent = '', lastLink;
  let restoring = false, deferredNavigation = null, lastHistory = '', navigationEpoch = 0;
  function cancelOldNavigation() {
    navigationEpoch++; deferredNavigation=null; restoring=false;
  }
  let openCredits = null, creditsShown = false;
  const reloadSnapshot=performance.getEntriesByType?.('navigation')[0]?.type==='reload' ? history.state?.pawntedFunnel : null;
  const reloadStyles=reloadSnapshot?.view==='styles';
  if(reloadStyles)root.dataset.reloadView='styles';
  history.replaceState({...history.state,pawntedFunnel:{view:'styles',stage:'upload'}},'',location.href);
  function rememberNavigation(current) {
    if (restoring || selecting || current?.busy || current?.stage === 'waiting') return;
    const snapshot = {view:document.body.dataset.funnelView || 'styles',stage:current?.stage === 'preview' ? 'product' : current?.stage || 'upload',style:current?.style || '',portraitId:current?.portraitId || ''};
    const key = JSON.stringify(snapshot);
    if (key === lastHistory) return;
    const previous = history.state?.pawntedFunnel;
    if (!lastHistory || (previous?.view === snapshot.view && previous?.stage === snapshot.stage && previous?.style === snapshot.style && previous?.portraitId === snapshot.portraitId))
      history.replaceState({...history.state,pawntedFunnel:snapshot},'',location.href);
    else history.pushState({...history.state,pawntedFunnel:snapshot},'',location.href);
    lastHistory = key;
  }
  async function restoreNavigation(snapshot) {
    if (!snapshot) return;
    const epoch = ++navigationEpoch;
    if (state()?.busy && !window.PawntedStudio.prepareBackNavigation()) {deferredNavigation=snapshot;return;}
    deferredNavigation=null;
    restoring=true;
    try {
      if (mounted && snapshot.view !== 'styles') await window.PawntedStudio.navigate(snapshot);
      if (epoch !== navigationEpoch) return;
      document.body.dataset.funnelView=snapshot.view;
      sync(); scrollTo(document.querySelector('.pw-funnel-steps'));
      lastHistory=JSON.stringify(snapshot);
    } finally {if (epoch === navigationEpoch) restoring=false;}
  }
  window.addEventListener('popstate',event=>void restoreNavigation(event.state?.pawntedFunnel));
  const state = () => window.PawntedStudio?.getState();
  const emit = (name, detail) => {
    try { window.Shopify?.analytics?.publish('pawnted:' + name, detail); } catch {}
  };
  const scrollTo = node => node?.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  function sync() {
    const current = state();
    const view = document.body.dataset.funnelView === 'studio' ? current?.stage || 'upload' : 'styles';
    const heading=document.querySelector('[data-funnel-step-title]');
    if(heading)heading.textContent=view==='styles' ? 'Choose Your Art Style' : view==='upload' ? 'Upload Your Photos' : 'Order Your Prints';
    const subtitle=document.querySelector('[data-funnel-step-subtitle]');
    if(subtitle)subtitle.textContent=view==='styles' ? 'For you, your pets, or everyone together.' : view==='upload' ? 'Add 1–4 photos. We’ll bring everyone together in one artwork.' : 'Choose two artworks in the same size and finish. One is free.';
    steps.forEach(button => {
      const step = button.dataset.funnelStep;
      button.disabled = selecting || (['styles','upload'].includes(step) ? Boolean(current && !current.canNavigateBack) : Boolean(current?.busy)) || (step !== 'styles' && !current) || (['preview','product'].includes(step) && !current?.canOpenPrint);
      if (step === (['waiting','product','cart'].includes(view) ? 'preview' : view)) button.setAttribute('aria-current','step'); else button.removeAttribute('aria-current');
    });
    const note = root.querySelector('[data-funnel-credit-note]');
    if (note && current?.credits) {
      const {free,paid,total} = current.credits;
      note.textContent = free > 0 ? `${free} free previews left today. No card needed.` : paid > 0 ? `${paid} purchased previews left. This preview uses 1 credit.` : 'Your free previews refill daily. Come back tomorrow, or add 20 for US$10.';


    }
    if (openCredits && !creditsShown && current?.credits?.total === 0 && !current.busy && document.body.dataset.funnelView === 'studio' && ['upload','product'].includes(current.stage)) {creditsShown = true; openCredits();}
    const eventKey = view + ':' + (current?.portraitId || '') + ':' + (current?.style || '');
    if (eventKey !== lastEvent) {
      lastEvent = eventKey;
      emit('funnel_step_viewed', {step:view,style:current?.style || null});
    }
    rememberNavigation(current);
    if (deferredNavigation && !current?.busy) {const next=deferredNavigation;deferredNavigation=null;void restoreNavigation(next);}
  }
  function showStudio() { document.body.dataset.funnelView = 'studio'; sync(); }
  function showStyles() {
    if (selecting || (window.PawntedStudio && !window.PawntedStudio.prepareBackNavigation())) return;
    cancelOldNavigation();
    document.body.dataset.funnelView = 'styles';
    sync(); scrollTo(document.querySelector('#funnel-styles'));
    lastLink?.focus({preventScroll:true});
  }
  function mount() {
    if (mounted) return;
    mounted = true;
    const intro = document.createElement('div');
    intro.className = 'pw-funnel-upload-intro';
    intro.innerHTML = '<h2 data-funnel-upload-title>Now, make it yours.</h2><p data-funnel-upload-copy>Add clear photos of the people and pets you want painted.</p><p class="pw-funnel-credit-note" data-funnel-credit-note>Preview before you pay. Prints are optional.</p>';
    root.querySelector('[data-photo-panel]').before(intro);
    const extras = document.createElement('div');
    extras.className = 'pw-funnel-extras';
    const background = root.querySelector('.pw-background-options');
    background.before(extras);
    // Always visible, name first, few words.
    const nameLabel = root.querySelector('[data-name]').closest('label');
    [nameLabel,root.querySelector('#pw-name-help'),background,root.querySelector('#pw-background-help')].forEach(node => extras.append(node));
    const savedArtwork = root.querySelector('[data-library]');
    root.querySelector('.pw-pdp-grid').after(savedArtwork);
    savedArtwork.querySelector('h2').textContent = 'Your saved artwork';
    savedArtwork.querySelector('.pw-library-heading p').textContent = 'Browse your previous creations. Tap a piece to choose its print size and finish.';
    savedArtwork.querySelector('[data-close-library]').hidden = true;
    savedArtwork.setAttribute('aria-label', 'Your saved artwork');
    nameLabel.firstChild.textContent = 'Name on the artwork ';
    root.querySelector('[data-name]').placeholder = 'Optional, e.g. Luna & Milo';
    background.querySelector('legend').firstChild.textContent = 'Background ';
    const note = document.createElement('p');
    note.className = 'pw-funnel-print-note';
    note.textContent = 'Love it on your wall? Prints from US$49, with free shipping. Choose your size next.';
    root.querySelector('.pw-review-heading').after(note);
    const back = root.querySelector('.pw-studio-top > a');
    back.href = '#funnel-styles'; back.textContent = 'Try another style';
    back.onclick = event => {event.preventDefault(); showStyles();};
    const creating = window.PawntedStudio.continueCreating;
    window.PawntedStudio.continueCreating = action => action === 'styles' ? showStyles() : (showStudio(), creating(action));
    // One style chooser: the step 1 gallery. The style card and the options sheet both return to it.
    const card = root.querySelector('[data-change-style]');
    card.onclick = event => {event.preventDefault(); showStyles();};
    card.removeAttribute('aria-haspopup'); card.removeAttribute('aria-controls'); card.removeAttribute('aria-expanded');
    card.querySelector('.pw-style-switch-action').textContent = 'Change';
    window.PawntedFunnel = {showStyles};
    // One FAQ list under the print options: delivery, refunds, materials and cropping, all styled alike.
    const faq = root.querySelector('[data-print-help]');
    [...faq.querySelectorAll('details')].slice(1).forEach(node => node.remove());
    const refunds = document.createElement('details');
    refunds.innerHTML = '<summary>Refunds &amp; returns</summary><p>Every print is backed by our 30-day money-back guarantee. Not in love with it? <a href="/pages/contact">Contact us</a> within 30 days with your order number for a full refund.</p>';
    faq.append(refunds, ...[...root.querySelectorAll('.pw-pdp-details details')].slice(0, 2));
    const icon = path => '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' + path + '</svg>';
    const trust = document.createElement('ul');
    trust.className = 'pw-trust';
    trust.innerHTML = '<li>' + icon('<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/>') + '<strong>Free shipping</strong><span>Taxes at checkout</span></li>' +
      '<li>' + icon('<path d="M20 6 9 17l-5-5"/>') + '<strong>Your approved artwork</strong><span>Printed as you see it</span></li>' +
      '<li>' + icon('<rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/>') + '<strong>Secure checkout</strong><span>With Shopify</span></li>';
    root.querySelector('.pw-buy .pw-reassurance').after(trust);
    const guarantee = document.createElement('div');
    guarantee.className = 'pw-guarantee';
    guarantee.innerHTML = icon('<path d="M12 3 5 6v5c0 4.5 3 8.3 7 10 4-1.7 7-5.5 7-10V6Z"/><path d="m9 12 2 2 4-4"/>') + '<div><strong>30-day money-back guarantee</strong><span>Not in love with your print? Tell us within 30 days for a full refund.</span></div>';
    trust.after(guarantee);
    const gift = document.createElement('div');
    gift.className = 'pw-free-gift';
    gift.innerHTML = icon('<path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13"/><path d="M12 7c-1.500-3-5-3-5-1s3 1.500 5 1Zm0 0c1.500-3 5-3 5-1s-3 1.500-5 1Z"/>') + '<div><strong>Free digital print</strong><span>Emailed after you order</span></div><em>FREE</em>';
    root.querySelector('[data-cart]').after(gift);
    const row = document.createElement('div'); row.className = 'pw-buy-more';
    root.querySelector('[data-create-another-style]').before(row);
    row.append(root.querySelector('[data-create-another-style]'), root.querySelector('[data-buy-options]'));
    root.querySelector('[data-buy-options]').className = 'pw-secondary';
    // Credits live in the site header, not in the body of the steps.
    const badge = root.querySelector('[data-credit-badge]'), actions = document.querySelector('.atelier-header-actions');
    // The credits panel opens as a modal from that badge instead of sitting in the page.
    const credits = document.createElement('dialog');
    credits.className = 'pw-credit-dialog'; credits.dataset.creditDialog = ''; credits.setAttribute('aria-label','Your generation credits');
    const closeCredits = document.createElement('button');
    closeCredits.type = 'button'; closeCredits.className = 'pw-secondary'; closeCredits.dataset.closeCredits = ''; closeCredits.textContent = 'Close';
    closeCredits.onclick = () => credits.close();
    credits.append(closeCredits, root.querySelector('.pw-credit-card')); root.append(credits);
    credits.addEventListener('click', event => {if (event.target === credits) credits.close();});
    // Buying credits continues in the bag drawer.
    root.querySelector('[data-credit-topup]').addEventListener('click', () => credits.close());
    if (badge && actions) {
      actions.prepend(badge); const refresh = badge.onclick;
      openCredits = () => {showStudio(); if (!credits.open) credits.showModal(); return refresh();};
      badge.onclick = openCredits;
    }
    new MutationObserver(sync).observe(root,{attributes:true,attributeFilter:['data-funnel-state']});
    sync();
  }
  function loadStudio() {
    if (loading) return loading;
    loading = new Promise((resolve,reject) => {
      const css = document.createElement('link'); css.rel = 'stylesheet'; css.href = assets.css;
      const script = document.createElement('script'); script.src = assets.js;
      let finished = false;
      const timer = setTimeout(() => fail(), 20000);
      function fail() {
        if (finished) return; finished = true; clearTimeout(timer);
        css.remove(); script.remove(); loading = null;
        reject(new Error('The studio could not load. Please tap your style to try again.'));
      }
      css.onerror = script.onerror = fail;
      css.onload = () => {if (!finished) document.head.append(script);};
      script.onload = () => {
        if (finished) return;
        if (!window.PawntedStudio) return fail();
        finished = true; clearTimeout(timer); mount(); resolve();
      };
      document.head.append(css);
    });
    return loading;
  }
  async function selectStyle(id, link, resume = false) {
    if (selecting || state()?.busy || !links.some(item => item.dataset.funnelStyle === id)) return;
    cancelOldNavigation();
    selecting = true; lastLink = link || links.find(item => item.dataset.funnelStyle === id);
    status.hidden = true; status.textContent = ''; setLoader(true); sync();
    const address = new URL(location.href); address.searchParams.set('style',id);
    history.replaceState(history.state,'',address.pathname + address.search + address.hash);
    try {
      await loadStudio();
      if (!(resume && state().resumeOnReload && state().style === id) && !window.PawntedStudio.chooseStyle(id) && state().style !== id) throw new Error('Please wait for your current portrait to finish.');
      // Reveal a complete print form; catalogue loading must not push the buy panel down.
      if (state().stage === 'product') await window.PawntedStudio.preparePrintOptions();
      await Promise.race([document.fonts.ready, new Promise(resolve => setTimeout(resolve, 1500))]);
      showStudio(); setLoader(false); status.hidden = true; delete document.documentElement.dataset.funnelEntry;
      scrollTo(document.querySelector('.pw-funnel-steps')); root.querySelector('[data-funnel-upload-title]').setAttribute('tabindex','-1');
      root.querySelector('[data-funnel-upload-title]').focus({preventScroll:true});
    } catch (error) {setLoader(false); delete document.documentElement.dataset.funnelEntry; status.hidden=false; status.textContent = error.message; scrollTo(status); }
    finally {setLoader(false); selecting = false; sync();}
  }
  links.forEach(link => link.addEventListener('click',event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); void selectStyle(link.dataset.funnelStyle, link);
  }));
  steps.forEach(button => button.onclick = () => {
    if (button.disabled) return;
    cancelOldNavigation();
    const step = button.dataset.funnelStep;
    if (step === 'styles') return showStyles();
    showStudio();
    if (step === 'upload') window.PawntedStudio.backToPhotos();
    else if (['preview','product'].includes(step)) void window.PawntedStudio.openPrint({quiet:true});
    scrollTo(document.querySelector('.pw-funnel-steps')); sync();
  });
  // Styles are grouped into titled sections; the links on top jump to a group.
  document.querySelectorAll('[data-funnel-jump]').forEach(link => link.addEventListener('click', event => {event.preventDefault(); scrollTo(document.getElementById(link.getAttribute('href').slice(1)));}));
  sync();
  const requested = new URLSearchParams(location.search).get('style');
  if (!reloadStyles && requested && links.some(link => link.dataset.funnelStyle === requested)) void selectStyle(requested, undefined, true);
  else delete document.documentElement.dataset.funnelEntry;
  // Restore saved portraits and navigation without leaving the style gallery.
  // First-time visitors still get the lightweight gallery with no studio requests.
  if (reloadStyles) void loadStudio().then(sync).catch(error => {
    status.hidden=false;status.textContent=error.message;
  });
})();
